// @flow

import z from 'app/common/z';

const log = (...args: mixed[]) => {
  // eslint-disable-next-line no-console
  if (z.cfg.debug && console && console.log) {
    console.log.apply(console, args); // eslint-disable-line no-console
  }
};

export default log;
